import { Geometric } from '../types';

const earthRadio = 6378.137; //Radio de la tierra en m
const earthRadiusNM = 3440.07; // Radio de la Tierra en millas náuticas

function degreesToRadians(degrees: number): number {
  return (degrees * Math.PI )/ 180;
}

/**
 * @description Calculate the distance between two coordinates and return in Meters
 * @param lastGeometric
 * @param currentGeometric
 */
export function calcDistanceMeter(lastGeometric: Geometric, currentGeometric: Geometric): number {

  const { coordinates: lastCoordinates } = lastGeometric || {};
  const { coordinates: currentCoordinates } = currentGeometric || {};

  if(!currentCoordinates || !lastCoordinates) return 0;

  const [[lng1, lat1], [lng2, lat2]] = [lastCoordinates, currentCoordinates] as number[][];

  const dLat = degreesToRadians(lat2 - lat1);
  const dLong = degreesToRadians(lng2 - lng1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadio * c * 1000;
}

export function calcDistanceNauticalMiles(lastGeometric: Geometric, currentGeometric: Geometric): number {
  const { coordinates: lastCoordinates } = lastGeometric || {};
  const { coordinates: currentCoordinates } = currentGeometric || {};

  if(!currentCoordinates || !lastCoordinates) return 0;

  const [[lon1, lat1], [lon2, lat2]] = [lastCoordinates, currentCoordinates] as number[][];

  const dLat = degreesToRadians(lat2 - lat1);
  const dLon = degreesToRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distanceNM = earthRadiusNM * c;
  return distanceNM;
}
